import React from 'react'
import { useQuery } from '@tanstack/react-query'
import PublicEventsPictureGallery from './PublicEventsPictureGallery'
import { EventsTypes } from '../../interfaces/types'
import { EventsSectionContainer } from '../../styles/EventsPages/EventsSection'
import { fetchPublicEventsGallery } from '../../services/api'

const PublicEventsSection: React.FC = () => {
    const { data: eventTypes = [] } = useQuery<EventsTypes[]>({
        queryKey: ['public-events-gallery'],
        queryFn: fetchPublicEventsGallery,
    })

    return (
        <EventsSectionContainer>
            {eventTypes.map((event, index) => (
                <PublicEventsPictureGallery 
                key={index} 
                eventsType={event}
                side={index % 2 === 0 ? 'right' : 'left'} />
            ))}
        </EventsSectionContainer>
    )
}

export default PublicEventsSection